/* RESPONSIBLE TEAM: team-ai-agent */
import Model, { attr } from '@ember-data/model';
import { buildValidations, validator } from 'ember-cp-validations';
import { fragment } from 'ember-data-model-fragments/attributes';
import { states, type State } from 'embercom/models/data/matching-system/matching-constants';
import { VISUALIZATION_TYPES } from 'embercom/models/reporting/custom/visualization-options';

const Validations = buildValidations({
  name: [
    validator('presence', {
      presence: true,
      messageKey: 'ai-agent.guidance.validation-errors.title.empty',
    }),
    validator('length', { max: 100, min: 1 }),
  ],
});

enum Stat {
  USED = 'used',
  RESOLVED = 'resolved',
  ROUTED = 'routed',
}

export default class EscalationRule extends Model.extend(Validations) {
  @attr('string') declare name: string;
  @attr('number') declare state: State;
  @attr('date') declare createdAt: Date;
  @fragment('predicates/predicate-group') declare predicateGroup: any;

  get enabled() {
    return this.state === states.live;
  }

  get hasPredicates() {
    return this.predicateGroup.hasPredicates;
  }

  get chartDefinitions() {
    return {
      used: this.chartDefinitionForStat(Stat.USED),
      resolved: this.chartDefinitionForStat(Stat.RESOLVED),
      routed: this.chartDefinitionForStat(Stat.ROUTED),
    };
  }

  chartDefinitionForStat(stat: Stat): any {
    let metricId = '';
    let chartId = `${this.id}_${stat}`;

    switch (stat) {
      case Stat.USED:
        metricId = 'fin.conversations_participated.count';
        break;
      case Stat.RESOLVED:
        metricId = 'fin.resolution_rate';
        break;
      case Stat.ROUTED:
        metricId = 'fin.routed_to_team_rate';
        break;
      default:
        throw new Error(`Invalid stat: ${stat}`);
    }

    return {
      id: chartId,
      visualization_type: VISUALIZATION_TYPES.COUNTER,
      chart_series: [
        {
          metric_id: metricId,
          filters: {
            type: 'and',
            filters: [
              {
                type: 'category',
                data: {
                  property: 'fin.escalation_rules_applied.escalation_rule_ids',
                  attribute: 'conversation.fin.escalation_rules_applied.escalation_rule_ids',
                  values: [this.id],
                },
              },
            ],
          },
        },
      ],
    };
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ai-agent/escalation-rule': EscalationRule;
  }
}
